import './styles.sass';

import React from 'react';
import Transition from 'components/Explorer/Transition';
import { Link } from 'react-router-dom';

import Gauge from 'components/Explorer/Gauge';
import TopItemList from 'components/Highlights/TopItemList';
import NumberHelper from 'util/number_helper';
import * as QueryParams from 'components/Explorer/models/query_params';
import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

const COLORS = ['#009688', '#00796B', '#004D40'];

const linkForSubjectArea = (params, area) => {
  const filters = { ...(params.filters || {}), 'field_of_research_codes[]': [area.id] };
  return QueryParams.locationFor(QueryParams.withFilters(params, filters), '/mentions');
};

const trackJumpLink = () => {
  Analytics.trackEvent('highlights-click-jump-link', { jumpedTo: 'top-subject-areas' });
};

const TopSubjectAreas = () => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData('highlights/top_subject_areas', params, { reloadOn: ['filters'] });

  const isLoading = loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS;
  const hasResults = Array.isArray(data) && data.length > 0;

  const rank = (area, index) => (
    <TopItemList.Item key={area.id}>
      <Gauge percentage={area.ratio} color={COLORS[index % COLORS.length]} />
      <div className="description">
        <div className="title">
          <Link to={linkForSubjectArea(params, area)}>{area.name}</Link>
        </div>
        <div className="meta">
          {I18n.htmlSafe('Explorer.Highlights.TopSubjectAreas.meta.mentions', {
            count: area.mentions,
            formattedCount: NumberHelper.formatStatistic(area.mentions)
          })}
          <span>&nbsp;</span>
          {I18n.htmlSafe('Explorer.Highlights.TopSubjectAreas.meta.outputs', {
            count: area.outputs,
            formattedCount: NumberHelper.formatStatistic(area.outputs)
          })}
        </div>
      </div>
    </TopItemList.Item>
  );

  const content = () => {
    if (loading === Loading.ERROR) {
      return <div className="Highlights-error-message">{I18n.t('Explorer.loading_error')}</div>;
    }
    return (
      <div key="content" className="Highlights-content Highlights-TopSubjectAreas-content">
        {hasResults ? (
          <TopItemList>{data.map(rank)}</TopItemList>
        ) : (
          <div className="Highlights-content-empty-message">{I18n.t('Explorer.Highlights.TopSubjectAreas.empty')}</div>
        )}
      </div>
    );
  };

  return (
    <div className="Highlights-TopSubjectAreas Highlights-block">
      <h2 className="Highlights-title">{I18n.t('Explorer.Highlights.TopSubjectAreas.title')}</h2>
      <div className="Highlights-content-wrapper">
        <Transition>
          {isLoading ? <div key="loadingMessage" className="Highlights-loading-message" /> : content()}
        </Transition>
        {hasResults && (
          <Link
            onClick={trackJumpLink}
            to={QueryParams.locationFor(params, '/mentions')}
            className="Highlights-jump-link"
          >
            {I18n.t('Explorer.Highlights.TopSubjectAreas.more')}
          </Link>
        )}
      </div>
    </div>
  );
};

export default TopSubjectAreas;
